import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import baseStyles from './styles/base';
import materialTheme from './styles/vendor/materialTheme';
import LocaleProvider from './components/locale/LocaleProvider';
import IconBase from './components/Icon/IconBase';
import { GoToTopButton } from './components/GoToTopButton/GoToTopButton';
import { ReadingProgressBar } from './components/ReadingProgressBar/ReadingProgressBar';
import { useCopyCodeBlock } from './hooks/useCopyCodeBlock';
import { useScrollSpySidebar } from './components/layout/Sidebar/useScrollSpySidebar';

const App = ({ locale, children }) => {
  useScrollSpySidebar();
  useCopyCodeBlock();

  return (
    <LocaleProvider locale={locale}>
      <>
        <Global styles={baseStyles} />
        <IconBase />
        <MuiThemeProvider theme={materialTheme}>{children}</MuiThemeProvider>
        <GoToTopButton />
        <ReadingProgressBar height={4} color='#6d3aec' trackColor='rgba(0,0,0,0.05)' />
      </>
    </LocaleProvider>
  );
};

App.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default App;
